import { clearManageFlowBooking } from '@/features/manage/manageActions';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useDispatch, useSelector } from '@/store/utils';
import { useEffect, type FC } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const ManageBookingLayout: FC = () => {
  const booking = useSelector(manageFlowBookingSelector);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      // Only clear on final unmount of the entire manage-booking flow
      dispatch(clearManageFlowBooking());
    };
  }, [dispatch]);

  const isIndexRoute =
    location.pathname === '/manage-booking' ||
    location.pathname === '/manage-booking/';

  console.log('[ManageBookingLayout] Guard check:', {
    pathname: location.pathname,
    isIndexRoute,
    hasBooking: !!booking,
  });

  // If on any sub-route but no booking in state, redirect to search
  if (!isIndexRoute && !booking) {
    console.log(
      '[ManageBookingLayout] No booking, redirecting to /manage-booking'
    );
    return <Navigate to="/manage-booking" replace />;
  }

  return <Outlet />;
};
